module.exports = __webpack_public_path__ + "static/sinead-slideshow-03-7326cfac5013ed67f8eaaacd6c7bd50e.jpg";